// extracted by mini-css-extract-plugin
export default {"link":"AuthNav_link__1DYPd","activeLink":"AuthNav_activeLink__pZa0r"};